<template>
  <div class="page-main">
    <div class="flex flex-y-center m-b-10">
      <div class="flex flex-y-center">
        <span>日期范围：</span>
        <e-date-picker type="daterange" :value.sync="searchData.create_date" />
      </div>
      <div class="flex flex-y-center m-l-10">
        <span>部门员工：</span>
        <div>
          <c-cascader-department-member
            :list.sync="searchData.department_member_list"
            :showAllLevels="false"
          />
        </div>
      </div>
      <div class="flex flex-y-center m-l-10">
        <span>所属地区：</span>
        <div>
          <c-cascader-address
            :list.sync="searchData.address_list"
            :showAllLevels="false"
            checkStrictly
          />
        </div>
      </div>
    </div>
    <!-- 表格 -->
    <vxe-grid ref="refTable" v-bind="tableOptions">
      <!-- slot_default -->
      <template #default_seq="{ rowIndex }">
        <span :class="seqClass(rowIndex)">{{ rowIndex + 1 }}</span>
      </template>
      <template #default_name="{ row, rowIndex }">
        <span :class="seqClass(rowIndex)">{{ row.name }}</span>
      </template>
    </vxe-grid>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchData: {
        create_date: [this.$util.getDate().sevenDay, this.$util.getDate().today],
        department_member_list: [],
        address_list: []
      },
      tableOptions: {
        loading: true,
        size: 'mini',
        border: true,
        'max-height': this.$util.getViewHeight() - 217,
        columns: [
          { type: 'seq', width: 100, title: '排名', slots: { default: 'default_seq' } },
          { field: 'name', title: '所属地区', slots: { default: 'default_name' } },
          { field: 'count', title: '客户数量' }
        ],
        data: []
      }
    }
  },
  watch: {
    searchData: {
      handler() {
        this.getListData()
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.tableOptions.loading = false
  },
  methods: {
    // 排名样式
    seqClass(index) {
      let result = []
      if (index < 3) result.push('f-bold')
      if (index === 0) result.push('c-st')
      if (index === 1) result.push('c-nd')
      if (index === 2) result.push('c-rd')
      return result
    },
    // 获取列表数据
    getListData() {
      this.tableOptions.loading = true
      let data = {
        address: this.searchData.address_list, // 所属地区
        filterData: {
          create_date: this.searchData.create_date
        }
      }
      let len = this.searchData.department_member_list.length
      if (len) {
        let departmentMemberId = this.searchData.department_member_list[len - 1]
        let isBumen = typeof departmentMemberId === 'number'
        if (isBumen) {
          data.filterData.bumen_id = departmentMemberId // 部门
        } else {
          data.filterData.saler_id = Number(departmentMemberId.slice(5)) // 员工，去除'user_'
        }
      }
      this.$api({
        method: 'post',
        url: '/admin/gcvip/workBench/diqu',
        data
      })
        .then((res) => {
          if (res.status === 200) {
            this.tableOptions.data = res.data.list
          }
        })
        .catch(() => {})
        .then(() => {
          this.tableOptions.loading = false
        })
    }
  }
}
</script>

<style lang="less" scoped>
.page-main {
  .c-st {
    color: #ff6400;
  }
  .c-nd {
    color: #42b983;
  }
  .c-rd {
    color: #f2be45;
  }
}
</style>
